const common = {
  nav: {
    home: 'Home',
    orderOnline: 'Order Online',
    deliverySchedule: 'Delivery Schedule',
    contact: 'Contact'
  },
  hero: {
    badge: 'Authentic Brazilian Cuisine',
    title1: 'Taste of',
    title2: 'Brazil',
    title3: 'Delivered Fresh',
    description: 'Experience the warmth and flavor of authentic Brazilian home cooking. Dita brings traditional recipes passed down through generations, made with love and the finest ingredients, straight to your door.',
    orderBtn: 'Order Online',
    menuBtn: 'View Menu',
    step1Title: '1. Choose',
    step1Desc: 'Select your favorite Brazilian dishes',
    step2Title: '2. Order',
    step2Desc: 'Place your order and schedule delivery',
    step3Title: '3. Receive',
    step3Desc: 'Enjoy fresh food delivered to your door'
  },
  instagram: {
    badge: 'Follow Us',
    title1: 'Fresh From',
    title2: 'Our Kitchen',
    subtitle: 'See what\'s cooking! Follow us on Instagram for daily specials, new dishes, and behind-the-scenes moments.'
  },
  menu: {
    subtitle: 'Our Specialties',
    title1: 'Traditional',
    title2: 'Brazilian',
    title3: 'Flavors',
    mainDishes: 'Main Dishes',
    desserts: 'Desserts',
    combos: 'Combo Meals'
  },
  orderOnline: {
    title: 'Order',
    titleAccent: 'Now',
    subtitle: 'Select your favorites and schedule delivery',
    cashOnly: 'Cash Payment Only',
    addToCart: 'Add to Cart',
    all: 'All',
    scheduleText1: 'Schedule your delivery',
    scheduleText2: 'with ease and enjoy',
    scheduleText3: 'authentic Brazilian flavors',
    scheduleBtn: 'Schedule Delivery'
  },
  deliverySchedule: {
    title: 'Schedule',
    titleAccent: 'Delivery',
    subtitle: 'Pick your preferred delivery date and time. We\'ll confirm your order via email.',
    calendlyNote: 'Select your preferred delivery date and time. We\'ll confirm your order via email.'
  },
  contact: {
    title: 'Get in Touch',
    subtitle: 'We\'d love to hear from you',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    submit: 'Send Message',
    sending: 'Sending...',
    success: 'Message sent successfully!',
    error: 'Failed to send message. Please try again.',
    info: {
      title: 'Contact Information',
      phone: 'Phone',
      email: 'Email',
      hours: 'Business Hours',
      hoursValue: 'Tue-Sun: 11:00 AM - 8:00 PM'
    }
  },
  footer: {
    language: 'LANGUAGE',
    quickLinks: 'QUICK LINKS',
    followUs: 'FOLLOW US',
    order: 'Order',
    delivery: 'Delivery',
    contact: 'Contact',
    copyright: '© 2025 Dita\'s Brazilian Food | Bilingual: English & Português',
    poweredBy: 'Website Builder'
  },
  cart: {
    title: 'Your Order',
    empty: 'Your cart is empty',
    total: 'Total',
    checkout: 'Proceed to Checkout',
    remove: 'Remove',
    quantity: 'Quantity',
    added: 'Added!'
  },
  orderForm: {
    title: 'Complete Your Order',
    customerInfo: 'Customer Information',
    deliveryInfo: 'Delivery Information',
    orderSummary: 'Order Summary',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone Number',
    address: 'Delivery Address',
    city: 'City',
    postalCode: 'Postal Code',
    deliveryDate: 'Preferred Delivery Date',
    deliveryTime: 'Preferred Delivery Time',
    specialInstructions: 'Special Instructions',
    paymentMethod: 'Payment Method',
    cashOnDelivery: 'Cash or Interact',
    submit: 'Place Order',
    submitting: 'Placing Order...',
    success: 'Order placed successfully! Check your email for confirmation.',
    error: 'Failed to place order. Please try again.'
  }
};

export default common;